import { useGetScopes } from "@/api/useScopes"
import { useUser } from "./useUser"

import type { ScopesResponse } from "@/api/useScopes.types"

export const getAllResourceScope = (response: ScopesResponse) => {
  return (response?.data || []).filter(({ isAllResources }) => isAllResources)
}

export const useScopesPresentation = () => {
  const { response: allResourceScopes } = useGetScopes(
    {},
    { select: getAllResourceScope }
  )
  const { user } = useUser()
  const currentScopeId = user?.currentScopeId

  return { isAllResourceScope: allResourceScopes?.[0]?.id === currentScopeId }
}
